import { isScg } from '../../utils/helper'
import * as color from './colors'
import * as scgColor from './scg-colors'

const currentColorTheme = isScg === true ? scgColor : color

export default currentColorTheme
